export default __webpack_public_path__ + "static/media/avatar6.6b39c674.svg";